import { useEffect } from "react";
import { Box, Alert } from "@mui/material";
import { useUiStore } from "../store/uiStore.js";

// Notifiche toast globali (in basso a destra), auto-dismiss dopo 4.5s.
export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  useEffect(() => {
    const timers = toasts.map((t) => setTimeout(() => dismiss(t.id), 4500));
    return () => timers.forEach(clearTimeout);
  }, [toasts, dismiss]);

  if (toasts.length === 0) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        maxWidth: 360
      }}
    >
      {toasts.map((t) => (
        <Alert key={t.id} severity={t.severity} variant="filled" onClose={() => dismiss(t.id)} sx={{ boxShadow: 3 }}>
          {t.message}
        </Alert>
      ))}
    </Box>
  );
}
